// extracted by mini-css-extract-plugin
export default {"container":"tenantSettings_container__0OpGp","loadingContainer":"tenantSettings_loadingContainer__TGdOJ","section":"tenantSettings_section__mycW+"};